import { render, staticRenderFns } from "./PhysicianRoomForm.vue?vue&type=template&id=e6bd2c36&"
import script from "./PhysicianRoomForm.vue?vue&type=script&lang=ts&"
export * from "./PhysicianRoomForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports